import React from 'react';
import AccessorialInfo from './AccessorialInfo';
import EditAccessorialForm from './EditAccessorialForm';
import CarrierMismatchBanner from './CarrierMismatchBanner';

const CarrierRateSection = ({
  t,
  editCarrierRate,
  formFields,
  referenceAccessorial,
  accessorial,
  fullShipment,
  onChange,
  onSave,
  onCancel,
  renderActions,
}) => {
  if (editCarrierRate) {
    const editAccessorial = {
      carrier_rate: formFields.carrier_rate,
      carrier_unit_qty: formFields.carrier_unit_qty,
      begin_datetime: formFields.begin_datetime,
      end_datetime: formFields.end_datetime,
      location: formFields.location,
      description: formFields.description,
      carrier_note: formFields.carrier_note,
    };
    return (
      <>
        <CarrierMismatchBanner
          t={t}
          accessorial={accessorial}
          shipment={fullShipment}
        />
        <EditAccessorialForm
          isCarrier
          carrier_status={formFields.carrier_status}
          shipper_status={formFields.shipper_status}
          accessorial={editAccessorial}
          referenceAccessorial={referenceAccessorial}
          onChange={onChange}
          onSave={onSave}
          onCancel={onCancel}
        />
      </>
    );
  }

  const currentAccessorial = {
    carrier_unit_qty: formFields.carrier_unit_qty,
    carrier_rate: formFields.carrier_rate,
    carrier_note: formFields.carrier_note,
    begin_datetime: formFields.begin_datetime,
    end_datetime: formFields.end_datetime,
    location: formFields.location,
    description: formFields.description,
    vendor: formFields.vendor,
    vendor_name: formFields.vendor_name,
    decline_reason_code: accessorial?.carrier_decline_reason_code,
    currency: accessorial?.currency,
  };

  return (
    <>
      <CarrierMismatchBanner
        t={t}
        accessorial={accessorial}
        shipment={fullShipment}
      />
      <AccessorialInfo
        dataTestId={'div-233f3844'}
        isCarrier
        accessorial={currentAccessorial}
        referenceAccessorial={referenceAccessorial}
        actions={renderActions}
      />
    </>
  );
};

export default CarrierRateSection;
